class QuantityPanel {
    constructor(element) {
        this.element = element;
        this.form = element.querySelector('[data-quantity-form]');
        this.input = element.querySelector('[data-quantity-input]');
        this.minus = element.querySelector('[data-quantity-minus]');
        this.plus = element.querySelector('[data-quantity-plus]');

        this.externalId = element.dataset.productExternalId;
        this.step = parseFloat(element.dataset.quantityStep);
        this.avail = parseFloat(element.dataset.quantityAvail);

        this.quantity = 0;
        this.availsMultiplier = 1;
        this.computedAvails = 1;

        this.keyupDebounced = _.debounce(() => this.keyup(), 1000);

        this.init();
        this.bind();
    }

    init() {
        // Множитель для максимального количества
        this.availsMultiplier = Math.floor(this.avail / this.step).toFixed(0);
        // Максимальное количество по множителям
        this.computedAvails = Math.round(this.availsMultiplier * this.step * 100) / 100;

        this.quantity = this.step;
        this.updateInput();
    }

    bind() {
        this.bindForm();
        this.bindButtons();
        this.bindInput();
    }

    bindForm() {
        this.form.addEventListener('submit', (e) => e.preventDefault());
    }

    bindButtons() {
        const instance = this;
        this.minus.addEventListener('click', (e) => {
            e.preventDefault();
            instance.decrease();
        });
        this.plus.addEventListener('click', (e) => {
            e.preventDefault();
            instance.increase();
        });
    }

    bindInput() {
        const instance = this;
        this.input.addEventListener('keyup', instance.keyupDebounced);
        this.input.addEventListener('restart', () => instance.restart());
    }

    increase() {
        const newValue = this.quantity + this.step;
        this.quantity = newValue < this.avail ? newValue : this.avail;

        this.updateInput();
    }

    decrease() {
        const newValue = this.quantity - this.step;
        this.quantity = newValue > this.step ? newValue : this.step;

        this.updateInput();
    }

    keyup() {
        this.setQuantity(this.input.value);
    }

    setQuantity(value) {
        value = parseFloat(value);
        value = value ? value : 0;

        // Текущий множитель
        const multiplier = Math.floor(value / this.step).toFixed(0);

        let newValue = multiplier * this.step;
        newValue = Math.round(newValue * 100) / 100;

        if (this.computedAvails && newValue > this.computedAvails) {   // Если набрано больше возможного
            newValue = this.computedAvails;
        } else if (newValue < this.step) { // Если набрано меньше минимального
            newValue = this.step;
        } else if (newValue < value && newValue + this.step <= this.computedAvails) { // Если отличается от набранного и можно подсунуть еще
            newValue += this.step;
        }

        this.quantity = newValue;
        this.updateInput();
    }

    updateInput() {
        let value = this.quantity;
        if (Number.isInteger(value)) {
            value = value.toFixed(0);
        } else {
            value = parseFloat(value.toFixed(2));
        }

        this.input.value = value;
    }

    restart() {
        this.quantity = this.step;
        this.updateInput();
    }
}


function findPanels() {
    document.querySelectorAll('[data-quantity-panel]:not([data-initialized="true"])')
        .forEach((element) => {
            element.dataset.initialized = "true";
            new QuantityPanel(element);
        });
}

document.addEventListener('DOMContentLoaded', findPanels);
document.addEventListener('DOMContentMutated', findPanels);